import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/student-submission-portal/components/StudentPortalShell.tsx");
